/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { PostUsersLogout200, PostUsersLogout400, PostUsersLogoutMutationResponse } from '../entities/PostUsersLogout'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { z } from 'zod'

/**
 * @description OK
 */
export const postUsersLogout200Schema = z.any() as unknown as ToZod<PostUsersLogout200>

/**
 * @description Bad Request
 */
export const postUsersLogout400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<PostUsersLogout400>

export const postUsersLogoutMutationResponseSchema = z.lazy(() => postUsersLogout200Schema) as unknown as ToZod<PostUsersLogoutMutationResponse>